<section class="login-page">
  <div class="flex flex-col gap-3 items-center">
    <div class="w-24 h-24">
      <img
        ngSrc="/assets/images/logo.png"
        class="w-full h-full"
        width="150"
        height="150"
      />
    </div>
    <p class="text-primary-main !font-bold text-sm">
      ARAD MEAT AUTOMATION SYSTEM
    </p>
  </div>

  <form
    class="min-w-80 min-h-64 flex flex-col gap-2 items-center shadow rounded-md p-4 bg-background-default"
    (submit)="submit()"
    [formGroup]="loginForm"
  >
    <app-input
      class="block w-full"
      formControlName="mobile_number"
      [formGroup]="loginForm"
      type="text"
      labelKey="auth.phoneLabel"
    ></app-input>
    <div class="relative w-full">
      <app-input
        class="block w-full"
        formControlName="password"
        [formGroup]="loginForm"
        [type]="!isPasswordVisible ? 'password' : 'text'"
        labelKey="auth.passwordLabel"
      >
      </app-input>
      <button
        class="absolute top-4 left-3"
        type="button"
        (click)="togglePasswordVisibility()"
      >
        <mat-icon>{{
          isPasswordVisible ? "visibility_off" : "visibility"
        }}</mat-icon>
      </button>

      <div class="login-page__forgot-password">
        <span routerLink="/forgot-password">{{
          "auth.forgotPassword" | translate
        }}</span>
      </div>
    </div>

    <div class="login-page__submit">
      <app-button
        variant="filled"
        color="primary-main"
        type="submit"
        size="large"
        [disabled]="!loginForm.dirty || isLoading"
        [isLoading]="isLoading"
        >{{ "auth.title" | translate }}
      </app-button>
    </div>
  </form>
</section>
